export const GOVGR_PANEL = "govgr-panel";
export const GOVGR_PANEL__CONFIRMATION = "govgr-panel--confirmation";
export const GOVGR_PANEL__TITLE = "govgr-panel__title";
export const GOVGR_PANEL__BODY = "govgr-panel__body";
